import { useHistory } from 'react-router-dom';
import { Button, Row, Col } from 'react-bootstrap';
import classNames from 'classnames/bind';
import './dotNavBar.scss';

const DotNavBar = (props) => {
  let history = useHistory();
  let maxIndex = props.items.length - 1;

  const handlingClick = (item) => {
    let isValid = props.beforeNext ? props.beforeNext() : true;
    if (isValid) {
      history.push(item.path, { from: history.location.pathname });
    }
  };

  let currentIndex = props.items.length -1;

  return (
    <div className="dot-container">
      <Row>
        {props.items.map((item, index) => {
          currentIndex = item.path === history.location.pathname ? index : currentIndex;
          return (
            <Col key={`key-${index}`}>
              <Row className="justify-content-md-center">
                <div
                  className={classNames({
                    'dot-line': true,
                    'dot-line-left': index === 0,
                    'dot-line-fill': index > 0 && index < maxIndex,
                    'dot-line-rigth': index === maxIndex
                  })}
                ></div>
                <Button
                  variant="light"
                  className={
                    classNames({
                      'dot-button': true,
                      'dot-selected': item.path === history.location.pathname,
                      'dot-ok': index < currentIndex,
                      'dot-error': item.hasError,
                    })
                  }
                  value={item.path}
                  onClick={() => handlingClick(item)}
                >
                  {item.number}
                </Button>
              </Row>
              <Row className="justify-content-md-center">
                <label>{item.label}</label>
              </Row>
            </Col>
          );
        })}
      </Row>
    </div>
  );
};

export default DotNavBar;
